module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"br":{"title":"Compartilhe:","tooltip":"Compartilhar no"},"en":{"title":"Share:","tooltip":"Share on"},"es":{"title":"Compartir","tooltip":"Compartir en"}}')
  delete Component.options._Ctor
}
